import { render, staticRenderFns } from "./AcoesRedeCredenciada.vue?vue&type=template&id=2e4b971a&scoped=true"
import script from "./AcoesRedeCredenciada.vue?vue&type=script&lang=js"
export * from "./AcoesRedeCredenciada.vue?vue&type=script&lang=js"
import style0 from "./AcoesRedeCredenciada.vue?vue&type=style&index=0&id=2e4b971a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4b971a",
  null
  
)

export default component.exports